import queryString from 'query-string'
import { refreshCurrentMediaUrl } from '../currentMedia/actions'

export const INIT_QUERY_PARAMS = 'INIT_QUERY_PARAMS'
export function initQueryParams(request){
    return function initQueryParams(dispatch){
        const {
            match: {
                params: {
                    arkName,
                    uuid,
                }
            },
            location: {
                search,
            }
        } = request

        const params = {
            arkName,
            uuid,
            search: queryString.parse(search),
        }

        dispatch({ type: INIT_QUERY_PARAMS, params })
    }
}

export const UPDATE_SEARCH_QUERY_PARAMS = 'UPDATE_SEARCH_QUERY_PARAMS'
export function updateSearchQueryParam(key, value)
{
    return function updateSearchQueryParam(dispatch) {
        dispatch({ type: UPDATE_SEARCH_QUERY_PARAMS, searchParam: { key, value } })
        dispatch(refreshCurrentMediaUrl())
    }
}

export function resetSearchQueryParam(searchParamKey)
{
    return function resetSearchQueryParam(dispatch) {
        dispatch(updateSearchQueryParam(searchParamKey, null))
    }
}
